import { useMemo } from "react";

import { useConfig } from "@jti/app-context/useConfig";

type UseCountryData = {
  countryName: string;
  countryCode: string;
};

export const useCountry = (): UseCountryData => {
  const config = useConfig();

  return useMemo(
    () => ({
      countryName: config.COUNTRY_NAME,
      countryCode: config.ISO_COUNTRY_CODE,
    }),
    [config.COUNTRY_NAME, config.ISO_COUNTRY_CODE]
  );
};
